var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoutIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 18,
  fill: "none",
  viewBox: "0 0 14 18",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C2514B",
  d: "M2.833.667a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5h8.333a2.5 2.5 0 0 0 2.5-2.5V14A.833.833 0 0 0 12 14v.833a.833.833 0 0 1-.834.834H2.833A.833.833 0 0 1 2 14.833V3.167a.833.833 0 0 1 .833-.834h8.333a.833.833 0 0 1 .834.834V4a.833.833 0 1 0 1.666 0v-.833a2.5 2.5 0 0 0-2.5-2.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C2514B",
  d: "M10.922 5.91a.833.833 0 0 0-1.178 1.18l1.077 1.077H7a.833.833 0 0 0 0 1.666h3.821l-1.077 1.078a.833.833 0 1 0 1.178 1.178l2.5-2.5a.833.833 0 0 0 0-1.178z"
})));
export { SvgLogoutIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/logoutIcon.svg";